import { render, staticRenderFns } from "./magazinesDetailComponent.vue?vue&type=template&id=393b1830&"
import script from "./magazinesDetailComponent.vue?vue&type=script&lang=ts&"
export * from "./magazinesDetailComponent.vue?vue&type=script&lang=ts&"
import style0 from "./magazinesDetailComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports